// /* eslint-disable  jsx-a11y/label-has-associated-control */ 
// import React, { useState } from 'react';
// import { makeStyles } from '@material-ui/core/styles';
// import { Button } from '@material-ui/core';
// import Loading from 'components_newui/Loading';
// // import CustomButton from '../components/button/View';


// const useStyles = makeStyles((theme) => ({
//     root: {
//         width: '100%',
//     },
//     basicDetailWrp: {
//         margin: '1rem 0 2rem 0',
//         padding: '1rem',
//         background: '#fff'
//     },
//     title: {
//         fontFamily: 'VodafoneRg-Regular',
//         fontSize: '1.25rem',
//         margin: '0 0 2rem 0',
//         textAlign: 'left',
//         color: "#333",
//     },
   
//     error: {
//         color: "red",
//         fontFamily: 'VodafoneRg-Regular',
//         fontSize: '1rem',
//         margin: '0 0 0.5rem 0',
//     },
//     labelname: {
//         fontFamily: 'VodafoneRg-bold',
//         fontSize: '1rem',
//         margin: '0 0 0.5rem 0',
//         textAlign: 'left',
//         color: "#333",
//         display: 'block',
//     },

//     wrpcols: {
//         display: 'grid',
//         gridTemplateColumns: '1fr 1fr',
//         gap: '1rem',
//         alignContent:'baseline',
//         maxHeight: '490px',
//         height:'100%',
//         overflow: 'auto',
//         paddingBottom:'1rem',
//     },
//     assignbtn:{
//         marginTop:'1.5rem',
//         color: '#fff',
//         border: '1px solid',
//         borderColor:'#e60000', 
//         display: 'block',
//         padding: '0.5rem',
//         fontSize: '1rem',
//         boxSizing: 'border-box',
//         textAlign: 'center',
//         transition: 'all 300ms ease',
//         fontFamily: 'VodafoneRg-Regular',
//         borderRadius: '5px',
//         backgroundColor: '#e60000',
//         cursor:'pointer',
//         '&:hover':{
//             backgroundColor:'#fff',
//             border:'1px solid #e60000',
//             color:'#e60000'
//         }
//     },
//     instructions: {
//         marginTop: theme.spacing(1),
//         marginBottom: theme.spacing(1),
//     },
// }));

//  const BusinessScorecardList = (props) => {
//     const classes = useStyles()
//     const {ChallengeTemplateId,ideaIdKey,putAddBusinessScoreCardFn,listScorecardTemplateLoading ,listScorecardTemplate,innovateAddBusinessScoreCardIsLoading,setDialogOpenBusinessScorecard} = props || {}
//     const [selectedTemplate, setSelectedTemplate] = React.useState(null);
    
//     console.log("BusinessScorecardList props ==>", props )
//     console.log("listScorecardTemplate list ==>", listScorecardTemplate ) 
//     console.log("selectedTemplate selected ==>", selectedTemplate )
//     console.log("ChallengeTemplateId selected at creation time of challenge==>", ChallengeTemplateId )

//     const handleSelect = (template) => {
//         setSelectedTemplate(template);
//     };

//     const handleAssignBusinessScorecard = ()=>{
//         const {id:scorecardTemplateID = null,scoreCardJson=''} = selectedTemplate  // run time rror that why put here
        
//         const objAssignBusinessScorecard={
//             ideaIdKey,
//             businessScoreCardTemplateId:scorecardTemplateID,
//             businessSCQuestionJson:scoreCardJson,
//         }
//         putAddBusinessScoreCardFn(objAssignBusinessScorecard)
//         setDialogOpenBusinessScorecard(false)
//     }

    
//     if (listScorecardTemplateLoading) return <Loading />
   

//   return (
//     <div>
//       <div className={classes.wrpcols}>
//           {
//               listScorecardTemplate?.map((templatelist, index) => {
//                   return (
//                       <IdeaTemplateSelectCard
//                           key={templatelist.templateName}
//                           ideaName={templatelist.templateName}
//                           currentIndex={index}
//                           onClick={() => handleSelect(templatelist)}
//                           templatelistId={templatelist.id}
//                           selectedTemplateId={ChallengeTemplateId || selectedTemplate?.id}
//                       />
//                   )
//               })
//           }
//       </div>
//       <button type='button' onClick={handleAssignBusinessScorecard} className={classes.assignbtn}>{innovateAddBusinessScoreCardIsLoading ? '...Loading' :  'Assign Business Scorecard'}</button> 
//     </div>
//   )
// }

// export default BusinessScorecardList;

// const useStylesIdeaTemplateSelectCard = makeStyles((theme) => ({
//     root: {
//       width: '100%',
//     },
//     labelName:{
//         fontFamily: 'VodafoneRg-bold', 
//         margin: '0 0 0.5rem 0', 
//         fontSize: '1.125rem',
//         textAlign: 'left',
//         color:"#333",
//         display:'block',
//     },
//     ideaTemplateCardBox:{
//         backgroundColor: 'rgba(230, 0, 1, 0.09)',
//         padding:'1rem',
//         border:0,
//         borderRadius:'4px',
//     },
//     selectedTemplate:{
//         boxShadow: '-3px 4px 1px #ec2828'
//     },
//     selectbtn:{
//         color: '#fff',
//         border: '1px solid',
//         borderColor:'#e60000', 
//         display: 'block',
//         padding: '0.5rem',
//         fontSize: '1rem',
//         boxSizing: 'border-box',
//         textAlign: 'center',
//         transition: 'all 300ms ease',
//         fontFamily: 'VodafoneRg-Regular',
//         borderRadius: '5px',
//         backgroundColor: '#e60000',
//         cursor:'pointer'
//     }
    
// }));

// const IdeaTemplateSelectCard = (props) => {
//     const { ideaName,currentIndex,onClick,selectedTemplateId,templatelistId} = props || {}
//   const classes =  useStylesIdeaTemplateSelectCard()
//     return(
//         <div className={`${classes.ideaTemplateCardBox}  ${selectedTemplateId !== templatelistId ? null : classes.selectedTemplate}`}>
//             {/* <span><FcIdea /></span> */}
//             <h3 className={classes.labelName}>{ideaName}</h3>
//             {selectedTemplateId !== templatelistId ? <button type='button' onClick={onClick} className={classes.selectbtn}>Select</button> : 
//             <button type='button' className={classes.selectbtn}>Selected</button> }
//         </div>
//     )
// }





/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useMemo, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Loading from 'components_newui/Loading';

const useStyles = makeStyles((theme) => ({
  wrpcols: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '1rem',
    maxHeight: '490px',
    overflow: 'auto',
    paddingBottom: '1rem',
  },
  assignbtn: {
    marginTop: '1.5rem',
    color: '#fff',
    border: '1px solid #e60000',
    padding: '0.5rem',
    fontSize: '1rem',
    textAlign: 'center',
    transition: 'all 300ms ease',
    borderRadius: '5px',
    backgroundColor: '#e60000',
    cursor: 'pointer',
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
}));

const BusinessScorecardList = ({
  ChallengeTemplateId,
  businessScoreCardTemplateId,
  ideaIdKey,
  putAddBusinessScoreCardFn,
  listScorecardTemplateLoading,
  listScorecardTemplate = [],
  innovateAddBusinessScoreCardIsLoading,
  setDialogOpenBusinessScorecard,
}) => {
  const classes = useStyles();

  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [validationError, setValidationError] = useState('');

  // ✅ Derived selected ID – no pre-selection when businessScoreCardTemplateId is blank
  const selectedTemplateId = useMemo(() => {
    if (selectedTemplate?.id) return selectedTemplate.id;

    // Only pre-select if businessScoreCardTemplateId already has a value
    if (businessScoreCardTemplateId !== null && businessScoreCardTemplateId !== undefined && businessScoreCardTemplateId !== '') {
      return Number(businessScoreCardTemplateId);
    }

    // Do NOT fall back to ChallengeTemplateId – user must explicitly choose
    return null;
  }, [selectedTemplate, businessScoreCardTemplateId]);

  const handleSelect = useCallback((template) => {
    setSelectedTemplate(template);
    setValidationError('');
  }, []);

  const handleAssignBusinessScorecard = useCallback(() => {
    if (!selectedTemplateId) {
      setValidationError('Please select a business score card');
      return;
    }

    const selected = selectedTemplate || listScorecardTemplate.find(t => t.id === selectedTemplateId);

    if (!selected) {
      setValidationError('Please select a business score card');
      return;
    }

    setValidationError('');

    const objAssignBusinessScorecard = {
      ideaIdKey,
      businessScoreCardTemplateId: selected.id,
      businessSCQuestionJson: selected.scoreCardJson || '',
    };

    putAddBusinessScoreCardFn(objAssignBusinessScorecard);
    setDialogOpenBusinessScorecard(false);
  }, [selectedTemplate, selectedTemplateId, listScorecardTemplate, ideaIdKey]);

  if (listScorecardTemplateLoading) return <Loading />;

  return (
    <div>
      <div className={classes.wrpcols}>
        {listScorecardTemplate.map((template) => (
          <IdeaTemplateSelectCard
            key={template.id}
            ideaName={template.templateName}
            onSelect={() => handleSelect(template)}
            isSelected={selectedTemplateId === template.id}
          />
        ))}
      </div>

      {validationError && (
        <p style={{ color: 'red', fontFamily: 'VodafoneRg-Regular', fontSize: '0.9rem', marginTop: '0.5rem' }}>
          {validationError}
        </p>
      )}

      <button
        type="button"
        onClick={handleAssignBusinessScorecard}
        className={classes.assignbtn}
        disabled={innovateAddBusinessScoreCardIsLoading}
      >
        {innovateAddBusinessScoreCardIsLoading ? 'Assigning...' : 'Assign Business Scorecard'}
      </button>
    </div>
  );
};

export default BusinessScorecardList;


const useStylesIdeaTemplateSelectCard = makeStyles(() => ({
    ideaTemplateCardBox: {
      backgroundColor: 'rgba(230, 0, 1, 0.09)',
      padding: '1rem',
      borderRadius: '4px',
    },
    selectedTemplate: {
      boxShadow: '-3px 4px 1px #ec2828',
    },
    labelName: {
      fontFamily: 'VodafoneRg-bold',
      fontSize: '1.125rem',
      marginBottom: '0.5rem',
      color: '#333',
    },
    selectbtn: {
      color: '#fff',
      border: '1px solid #e60000',
      padding: '0.5rem',
      fontSize: '1rem',
      textAlign: 'center',
      borderRadius: '5px',
      backgroundColor: '#e60000',
      cursor: 'pointer',
    },
  }));
  
  const IdeaTemplateSelectCardComponent = ({ ideaName, onSelect, isSelected }) => {
    const classes = useStylesIdeaTemplateSelectCard();
  
    return (
      <div
        className={`${classes.ideaTemplateCardBox} ${
          isSelected ? classes.selectedTemplate : ''
        }`}
      >
        <h3 className={classes.labelName}>{ideaName}</h3>
  
        <button
          type="button"
          onClick={onSelect}
          className={classes.selectbtn}
          disabled={isSelected}
        >
          {isSelected ? 'Selected' : 'Select'}
        </button>
      </div>
    );
  };
  
  const IdeaTemplateSelectCard = React.memo(IdeaTemplateSelectCardComponent);
  